import { fieldRenderers } from "../../../DynamicForm/fieldRenderers";

interface Props {
  fieldDef: any;
  value: any;
  onChange: (v: any) => void;
}

export default function FilterValueInput({ fieldDef, value, onChange }: Props) {
  
  if (!fieldDef) {
    return (
      <input
        type="string"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  }

  const type = fieldDef.file_type as keyof typeof fieldRenderers;

  const renderer = fieldRenderers[type];

  if (!renderer) {
    return (
      <input
        type="string"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  }

  return (
    <>
      {renderer(
        fieldDef,
        value,
        onChange,   
        undefined,  
        false,      
        (s) => s,   
        undefined,
        false       
      )}
    </>
  );
}
